import React from 'react';
import { styled } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
// eslint-disable-next-line jira/import-whitelist
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import { useIsHydrateRenderMode } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';
import imgSVG from './assets/next-gen-backlog-app-skeleton.tpl.svg';

export const NextGenBacklogSkeletonOld = () => <AppSkeletonImage src={imgSVG} />;

export const NextGenBacklogSkeletonNew = () => (
	<Wrapper>
		<AppSkeletonImage src={imgSVG} />
	</Wrapper>
);

const BacklogSkeleton = componentWithCondition(
	isVisualRefreshEnabled,
	NextGenBacklogSkeletonNew,
	NextGenBacklogSkeletonOld,
);

export const NextGenBacklogSkeleton = () => {
	const isPageHydrating = useIsHydrateRenderMode();

	let ssrPlaceholderProp: Record<string, string> = {};
	if (!isPageHydrating) {
		ssrPlaceholderProp = __SERVER__
			? { 'data-ssr-placeholder': 'software-backlog-skeleton' }
			: { 'data-ssr-placeholder-replace': 'software-backlog-skeleton' };
	}

	return (
		<div {...ssrPlaceholderProp}>
			<BacklogSkeleton />
		</div>
	);
};

// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Wrapper = styled.div({
	display: 'contents',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'>div > img, > div > object': {
		borderLeftWidth: '24px',
		borderRightWidth: '24px',
	},
});
